var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.ready
      ? _c("div", [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.getLink.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "mdi-card full-width q-pa-md" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                    },
                    [
                      _c(
                        "q-field",
                        {
                          staticClass: "q-pa-md",
                          class: {
                            "is-required": _vm.errors.has(
                              "Price",
                              _vm.validatorFormName
                            )
                          },
                          attrs: {
                            orientation: "vertical",
                            label: "Enter Price",
                            inset: "full",
                            icon: _vm.errors.has("Price", _vm.validatorFormName)
                              ? "star_border"
                              : "star",
                            "icon-color": _vm.errors.has(
                              "Price",
                              _vm.validatorFormName
                            )
                              ? "negative"
                              : "blue-5",
                            error: _vm.errors.has(
                              "Price",
                              _vm.validatorFormName
                            ),
                            "error-label": _vm.errors.first(
                              "Price",
                              _vm.validatorFormName
                            ),
                            helper:
                              "Enter the price you want to charge for a company's registration and receive the link to send them."
                          }
                        },
                        [
                          _c("q-input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|decimal:2",
                                expression: "'required|decimal:2'"
                              }
                            ],
                            staticClass: "no-shadow",
                            attrs: {
                              "data-vv-name": "Price",
                              type: "text",
                              name: "price",
                              "hide-underline": "",
                              "inverted-light": "",
                              color: _vm.errors.has("Price")
                                ? "negative"
                                : _vm.inputBgColor,
                              "validator-form-name": _vm.validatorFormName,
                              "data-vv-scope": _vm.validatorFormName
                            },
                            model: {
                              value: _vm.basePrice,
                              callback: function($$v) {
                                _vm.basePrice = $$v
                              },
                              expression: "basePrice"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6"
                    },
                    [
                      _c(
                        "q-field",
                        {
                          staticClass: "q-pa-md",
                          class: {
                            "is-required": _vm.errors.has(
                              "Type",
                              _vm.validatorFormName
                            )
                          },
                          attrs: {
                            orientation: "vertical",
                            label: "Type",
                            inset: "full",
                            icon: _vm.errors.has("Type", _vm.validatorFormName)
                              ? "star_border"
                              : "star",
                            "icon-color": _vm.errors.has(
                              "Type",
                              _vm.validatorFormName
                            )
                              ? "negative"
                              : "blue-5",
                            error: _vm.errors.has(
                              "Type",
                              _vm.validatorFormName
                            ),
                            "error-label": _vm.errors.first(
                              "Type",
                              _vm.validatorFormName
                            ),
                            helper: "What type of registration form?"
                          }
                        },
                        [
                          _c("q-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            staticClass: "no-shadow",
                            attrs: {
                              "data-vv-name": "Type",
                              options: _vm.typeOptions,
                              name: "type",
                              "hide-underline": "",
                              "inverted-light": "",
                              color: _vm.errors.has("Type")
                                ? "negative"
                                : _vm.inputBgColor,
                              "validator-form-name": _vm.validatorFormName,
                              "data-vv-scope": _vm.validatorFormName
                            },
                            model: {
                              value: _vm.type,
                              callback: function($$v) {
                                _vm.type = $$v
                              },
                              expression: "type"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _c(
                  "div",
                  [
                    _vm.link
                      ? _c(
                          "q-alert",
                          {
                            staticClass: "q-ma-lg",
                            attrs: {
                              type: "positive",
                              "icon-right": "link",
                              actions: _vm.copyClip
                            }
                          },
                          [_vm._v(_vm._s(_vm.link))]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _c("div", [
                  _c(
                    "div",
                    [
                      _c(
                        "q-btn",
                        {
                          staticClass: "q-ma-lg",
                          attrs: { color: "primary", push: "", size: "lg" },
                          on: { click: _vm.getLink }
                        },
                        [_vm._v("Get Registration Link")]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _c("q-inner-loading", { attrs: { visible: _vm.loading } })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }